import type { LiveConnection, LiveConnectionFactory } from '../application/liveConnection';

function liveHttpUrl(wsUrl: string): string {
  const url = new URL(wsUrl, typeof location === 'undefined' ? 'http://localhost' : location.href);
  url.protocol = url.protocol === 'wss:' ? 'https:' : 'http:';
  if (url.pathname === '/api/logs/ws') url.pathname = '/api/logs/live';
  url.searchParams.delete('ticket');
  return url.toString();
}

export const browserLiveConnection: LiveConnectionFactory = (url) => {
  const source = new EventSource(liveHttpUrl(url), { withCredentials: true });
  const connection: LiveConnection = {
    get readyState() {
      return source.readyState === EventSource.CLOSED ? 3 : source.readyState;
    },
    onopen: null,
    onmessage: null,
    onclose: null,
    onerror: null,
    send() {},
    close() {
      source.close();
    },
  };
  source.onopen = () => connection.onopen?.();
  source.onmessage = (event) => connection.onmessage?.({ data: event.data });
  source.onerror = () => {
    if (source.readyState === EventSource.CLOSED) connection.onclose?.();
  };
  return connection;
};
